import { ManorMark, type MarkTone } from '@/components/ui/manor-mark';

interface LogoProps {
  variant?: 'full' | 'mobile';
  className?: string;
  alt?: string;
  /** Mark tone; defaults to theme-aware 'auto'. Use 'peppermint' for the sign-in hero. */
  tone?: MarkTone;
}

// Full lockup = mark + "manor" wordmark. The wordmark is live text in Jost
// (our display font) as an interim until an official Alphapipe wordmark asset
// arrives; it follows the theme via --text-primary. Size the full lockup with a
// font-size class (e.g. text-3xl) — the mark scales in em with the wordmark.
// The whole lockup announces once as "manor". The mobile variant is mark-only
// and sizes by height (e.g. h-12 w-auto).
export function Logo({ variant = 'full', className, alt = 'manor', tone = 'auto' }: LogoProps) {
  if (variant === 'mobile') {
    return <ManorMark tone={tone} className={className} alt={alt} />;
  }

  return (
    <span
      role="img"
      aria-label={alt}
      className={`inline-flex items-center gap-[0.32em] leading-none ${className ?? ''}`}
    >
      <ManorMark tone={tone} className="h-[1.25em] w-auto" alt="" />
      <span className="font-display font-bold italic lowercase tracking-tight text-[color:var(--text-primary)]">
        manor
      </span>
    </span>
  );
}
